import { makeRequest } from './utils'
import {
  SITE_ROUTES_API
} from './constants'

export const generateFetchByRequest = (request) => makeRequest(request)

export const getRoutes = () => generateFetchByRequest({ url: SITE_ROUTES_API })